import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import { store } from "@/commonui/store/index";
import { fmtMsg, isGuid, MessageHelper, NotificationType } from "commonui";
import { Paths } from "@/util/paths";
import { AppNavigationLocale } from "@/locales/localeid";

interface BreadCrumbRoute {
	path: string;
	breadcrumbName: string;
	params?: any;
}

@Module({ namespaced: true, name: "AppBreadCrumbState", store: store, dynamic: true })
class BreadCrumbModule extends VuexModule {
	routes: any[] = [];

	@Mutation
	async setBreadCrumbRoutes(routes: any[]) {
		this.routes = routes;
	}
}

export const AppBreadCrumbModule = getModule(BreadCrumbModule);
